
import { l3draggable, l3droppable } from '@/directives/l3dragDrop';
import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import SimpleMessageBox from './SimpleMessageBox.vue';

@Component({
  components: {
    SimpleMessageBox
   },
  directives: { l3draggable, l3droppable }
})
export default class AvatarWithDnD extends Vue {
  @PropSync("image", { type: String, default: "" })
  syncedImage!: string;
  @Prop({ type: [Number], default: 100 }) avatarSize!: number;
  @Prop({ type: [Number], default: 300 }) maxImageWidth!: number;
  @Prop({ type: [Number], default: 300 }) maxImageHeight!: number;

  showConfirmDelete = false;

  // open hidden file input
  openFileDialog() {
    const input = this.$refs.fileInput as HTMLInputElement | undefined;
    if (input) input.click();
  }

  // handle file selection and set base64 image
  onFileSelected(e: Event) {
    const input = e.target as HTMLInputElement;
    if (!input || !input.files || input.files.length === 0) return;
    const file = input.files[0];
    if (!file.type.startsWith('image/')) {
      this.$store.commit("ux/SB_FAILURE", {
        message: "Bei dieser Datei handelt es sich nicht um ein Bild.",
        timeout: 0
      });
      input.value = '';
      return;
    }
    const reader = new FileReader();
    reader.onload = (ev: any) => {
      this.syncedImage = ev.target.result;
      input.value = '';
    };
    reader.readAsDataURL(file);
  }

  onDeleteLogo() {
    this.syncedImage = "";
  }

  get dropOptions() {
    return {
      accept: (data: any, ev?: DragEvent) => {
        if (!data) return false;
        // Check for FileDetailsVm
        // if (data?.fileType && (data.fileType == "Audio" || data.fileType == "Video")) return true;
        // Check for raw file array (dragged from OS / Browser)
        if (Array.isArray(data) && data[0] && data[0].name && data[0].type) return true;
        return false;
      },
      hoverClass: "drop-hover",
      transferTypes: ["Files"],
      targetGroups: ["image-file-details"],
      onDrop: async (data: any) => {
        if (Array.isArray(data) && data[0] && data[0].name && data[0].type) {
          // Check that it's an image file
          if (!data[0].type.startsWith("image/")) {
            this.$store.commit("ux/SB_FAILURE", {
              message: "Bei dieser Datei handelt es sich nicht um ein Bild.",
              timeout: 0
            });
            return;
          }
          // this.fileToUpload = data[0]; // trigger upload overlay
          // Convert to base64 for immediate display an assign to editBundle.image
          const file = data[0];
          console.log(`Original image size: ${Math.round(file.size / 1024)} KB`);
          const reader = new FileReader();
          reader.onload = async (e: any) => {
            this.syncedImage = await this.shrinkImageAsync(e.target.result);
          };
          reader.readAsDataURL(file);
        }
      }
    };
  }

  shrinkImageAsync(base64Image: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        let width = img.width;
        let height = img.height;

        // log original dimensions and image size in bytes
        console.log(`Original image dimensions: ${img.width} x ${img.height}`);

        // Calculate new dimensions
        let scale = 1;
        if (img.width > this.maxImageWidth || img.height > this.maxImageHeight) {
          let scaleX = this.maxImageWidth / img.width;
          let scaleY = this.maxImageHeight / img.height;
          scale = Math.min(scaleX, scaleY);
        }
        width = img.width * scale;
        height = img.height * scale;
        console.log(`Resized image dimensions: ${width} x ${height}`);

        // Create canvas to draw resized image
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Could not get canvas context');
          return;
        }
        ctx.drawImage(img, 0, 0, width, height);
        const resizedBase64 = canvas.toDataURL('image/jpeg');
        console.log(`Resized image size: ${Math.round((resizedBase64.length * (3 / 4)) / 1024)} KB`);
        resolve(resizedBase64);
      };
      img.onerror = (err) => {
        reject(err);
      };
      img.src = base64Image;
    });
  }

}
